module.exports = __webpack_public_path__ + "static/steak-lg-3ff28350bb068390e122bd38fa8076bf.jpg";